import * as contentRange from "content-range";

class AutocompleteResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource: ng.resource.IResourceService,
        config
    ) {
        return (headers = {}) => $resource(`${config.searchApi.url}/v2/autocomplete/:type`, { type: "@type" }, {
            query: {
                method: "GET",
                isArray: true,
                headers,
                params: {
                    query: "@query"
                },
                interceptor: {
                    response: res => {
                        const range = contentRange.parse(res.headers("Content-Range"));
                        const totalFound = range && range.length;
                        res.resource.metadata = { count: totalFound };
                        return res.resource;
                    }
                }
            }
        });
    }

}

angular
    .module("thor.core.autocomplete.resource", [])
    .factory("autocompleteResource", AutocompleteResource);
